<template>
  <div class="com-dota2-footer">
    <slot></slot>
    <span class="footer-text">查看比赛详情</span>
    <hb-icon common-arrow-right-filled />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.com-dota2-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
  background: rgba(247, 248, 249, 1);
  color: rgba(140, 145, 150, 1);
  .footer-text {
    font-size: 12px;
    line-height: 16px;
  }
  i {
    position: relative;
    width: 8px;
    height: 8px;
    margin-left: 2px;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 16px;
      transform: scale(0.5);
      transform-origin: left top;
    }
  }
}
</style>
